<template>
  <a-modal
    :visible="visible"
    :title="disTitle"
    :okText="$t('ok')"
    :cancel-text="$t('cancel')"
    :destroyOnClose="true"
    :width="600"
    @cancel="
      () => {
        this.visible = false
        $emit('cancel')
      }
    "
    @ok="() => save()"
  >
    <a-form-model
      :model="record"
      ref="editMachineForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item :label="$t('page_ops_machine_model_machine_picture')">
        <upload-img name="avatar" class-name="avatar-uploader" v-model="record.avatar" />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_type')" prop="deviceTypeId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-model="record.deviceTypeId"
          :placeholder="$t('please_select') + $t('page_ops_machine_model_machine_type')"
        >
          <a-select-option :value="item.id" :key="item.id" v-for="item in deviceTypes">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_name')" prop="name">
        <a-input
          v-model="record.name"
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_name')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_code')" prop="code">
        <a-input
          v-model="record.code"
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_code')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_serialNo')" prop="serialNo">
        <a-input
          v-model="record.serialNo"
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_serialNo')"
        />
      </a-form-model-item>
      <a-form-model-item
        :label="$t('page_ops_machine_model_machine_assemblyState')"
        prop="assemblyState"
      >
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          v-model="record.assemblyState"
          :placeholder="$t('please_select') + $t('page_ops_machine_model_machine_assemblyState')"
        >
          <a-select-option
            :value="item.key"
            v-for="(item, index) in assemblyStateList"
            :key="index"
          >
            {{ item.dictValue }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_systemName')">
        <a-input
          v-model="record.systemName"
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_systemName')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_softwareVersion')">
        <a-input
          v-model="record.softwareVersion"
          :placeholder="
            $t('common_please_input') + $t('page_ops_machine_model_machine_softwareVersion')
          "
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_deliveryTime')">
        <a-date-picker
          v-model="record.deliveryTime"
          type="date"
          :placeholder="$t('please_select') + $t('page_ops_machine_model_machine_deliveryTime')"
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_hyperlink')">
        <a-input
          v-model="record.hyperlink"
          :placeholder="$t('common_please_input') + $t('page_ops_machine_model_machine_hyperlink')"
        />
      </a-form-model-item>
      <a-form-model-item :label="$t('page_ops_machine_model_machine_config_file')">
        <machine-fie-list
          :fileList="attachFilesList"
          @saveList="(value) => saveFile(value)"
        ></machine-fie-list>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import {
  CreateOrUpdateMachineDTO,
  MachineServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'
import {
  DeviceTypeServiceProxy,
  DeviceTypePageDTO,
  Query
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { ServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
import MachineFieList from './MachineFieList.vue'
import moment from 'moment'
import dayjs from 'dayjs'

const dictSrvProxy = new DictServiceProxy()
const machineSrvProxy = new MachineServiceProxy()
const deviceTypeSrvProxy = new DeviceTypeServiceProxy()
const sProxy = new ServiceProxy()

export default {
  components: {
    MachineFieList
  },
  props: {},
  data() {
    return {
      visible: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        code: [
          {
            required: true,
            message: this.$t('page_ops_machine_model_code_required'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('page_ops_machine_model_name_required'),
            trigger: 'blur'
          }
        ],
        serialNo: [
          {
            required: true,
            message: this.$t('page_ops_machine_model_serialno_required'),
            trigger: 'blur'
          }
        ],
        deviceTypeId: [
          {
            required: true,
            message: this.$t('page_ops_machine_model_type_required'),
            trigger: 'change'
          }
        ],
        assemblyState: [
          {
            required: true,
            message: this.$t('page_ops_machine_model_assemblystate_required'),
            trigger: 'change'
          }
        ]
      },
      record: {},
      deviceTypes: [],
      assemblyStateList: [],
      machineId: '0',
      fileList: [],
      attachFilesList: []
    }
  },
  computed: {
    disTitle() {
      return this.machineId != '0'
        ? this.$t('page_ops_machine_model_edit_machine')
        : this.$t('page_ops_machine_model_create_machine')
    }
  },
  methods: {
    saveFile(list) {
      this.fileList = list
    },
    open(id) {
      this.visible = true
      this.attachFilesList = []
      this.machineId = id
      dictSrvProxy.dictionary('machine-assembly-state').then((res) => {
        this.assemblyStateList = res.data.map((c) => {
          c.key = Number(c.dictKey)
          return c
        })
      })
      sProxy.getBizAttachListUsingGET(id, 'work_station_of_machine').then((res) => {
        this.attachFilesList = res.data
      })

      machineSrvProxy.getForEdit(id).then((res) => {
        res.deliveryTime = res.deliveryTime ? moment(res.deliveryTime) : null
        this.record = res
      })

      const pageDto = new DeviceTypePageDTO()
      pageDto.query = new Query()
      pageDto.query.current = 1
      pageDto.query.size = -1

      deviceTypeSrvProxy.pageDeviceType(pageDto).then((res) => {
        this.deviceTypes = res.records
      })
    },
    handleChange(e) {
      this.value = e.target.value
    },
    save() {
      this.$refs.editMachineForm.validate((valid) => {
        if (valid) {
          const dto = new CreateOrUpdateMachineDTO()
          dto.init(this.record)
          dto.attachFiles = this.fileList.map((res) => {
            return res.attachId
          })
          dto.deliveryTime = dto.deliveryTime ? dayjs(dto.deliveryTime).format('YYYY-MM-DD HH:mm:ss') : null;
          machineSrvProxy.createOrUpdateMachine(dto).then((res) => {
            const msg = this.$t('save_success').toString()
            this.$message.success(msg)
            this.visible = false
            this.$emit('save')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .avatar-uploader {
  height: 180px !important;
  width: 160px !important;
}
/deep/ .img-uploader .img-panel {
  /* height: 292px !important; */
  height: 160px !important;
}
</style>
